import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { demographicProfileChartConfiguration } from '@features/executive-report/subdomains/visitation/slides/demographic-profile';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { ChartProps, Slide, TextProps } from '@features/powerpoint';
import { cardBackground } from './components/card-background';
import { defaultChartOptions } from '@features/executive-report/subdomains/visitation/slides/demographic-profile/default-chart-options';
import { chartSpecificOptions } from '@features/executive-report/subdomains/visitation/slides/demographic-profile/charts';

const CARD_X_START = 0.32;
const CARD_Y_START = 1.74;
const CARD_X_OFFSET = 3.21;
const CARD_Y_OFFSET = 2.24;
const CARDS_PER_ROW = 4;

type SlideProps = {
  demographicProfile: CampaignAnalyticsReport['demographicProfile'];
};

export const demographicProfileSlide = (props: SlideProps): Slide => {
  const chartConfiguration = demographicProfileChartConfiguration(
    props.demographicProfile
  );

  return {
    slideMaster: slideMasters.light,
    color: themeV2.colors.metricBlue,
    shapes: chartConfiguration.map((_, index) =>
      cardBackground({
        h: 2.1,
        w: 3.08,
        x: CARD_X_START + (index % CARDS_PER_ROW) * CARD_X_OFFSET - 0.1,
        y:
          CARD_Y_START +
          Math.floor(index / CARDS_PER_ROW) * CARD_Y_OFFSET -
          0.1,
      })
    ),
    texts: [
      {
        text: 'Demographic Profile (Saw the Ad & Visited)',
        options: {
          fontSize: 36,
          bold: true,
          h: 0.75,
          w: 12.67,
          x: 0.33,
          y: 0.25,
        },
      },
      ...chartConfiguration.map(
        (profile, index): TextProps => ({
          text: profile.title.toLocaleUpperCase(),
          options: {
            fontSize: 10,
            bold: true,
            align: 'center',
            color:
              index % 2 === 0
                ? themeV2.colors.metricBlue
                : themeV2.colors.inmarketGreen,
            h: 0.27,
            w: 2.11,
            x: 0.81 + (index % CARDS_PER_ROW) * CARD_X_OFFSET,
            y: 1.86 + Math.floor(index / CARDS_PER_ROW) * CARD_Y_OFFSET,
          },
        })
      ),
    ],
    charts: chartConfiguration.map((profile, index): ChartProps => {
      return {
        type: 'bar',
        data: [
          {
            name: 'Values',
            labels: profile.stats.map(stat => stat.name.toLocaleUpperCase()),
            values: profile.stats.map(stat => stat.value),
          },
        ],
        options: {
          ...defaultChartOptions,
          ...chartSpecificOptions[index],
          catAxisLabelColor: themeV2.colors.metricBlue,
          dataLabelColor:
            index % 2 === 0 || index === chartConfiguration.length - 1
              ? themeV2.colors.metricBlue
              : themeV2.colors.white,
          chartColors: [
            index % 2 === 0
              ? themeV2.colors.lightBlue
              : themeV2.colors.inmarketGreen,
          ],
          h: 1.64,
          w: 2.4,
          x: 0.67 + (index % CARDS_PER_ROW) * CARD_X_OFFSET,
          y: 2.07 + Math.floor(index / CARDS_PER_ROW) * CARD_Y_OFFSET,
        },
      };
    }),
  };
};
